var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.fetching,
      "rounded": "sm"
    }
  }, [_c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("staff_list_page.intro.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc text-center"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("staff_list_page.intro.form_desc")) + " ")]), _vm.isCanBinding ? _c('div', {
    staticClass: "field"
  }, [_vm.getModuleConfig('staff_list_page.intro.content') ? _c('div', {
    staticClass: "page__content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('staff_list_page.intro.content'))
    }
  }) : _vm._e()]) : _c('div', [_vm.getModuleConfig('staff_list_page.multiple_bind.forbid_text') ? _c('div', {
    staticClass: "page__content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('staff_list_page.multiple_bind.forbid_text'))
    }
  }) : _vm._e()])]), _c('div', {
    staticClass: "page__button s-space-y-4"
  }, [_vm.getModuleConfig('staff_list_page.intro.button_text') && _vm.isCanBinding ? _c('MemberButton', {
    attrs: {
      "button-style": "s-btn-outline-primary",
      "button-text": _vm.getModuleConfig('staff_list_page.intro.button_text'),
      "button-url": _vm.getModuleConfig('staff_list_page.intro.button_url'),
      "type": _vm.getModuleConfig('staff_list_page.intro.button_action')
    }
  }) : _vm._e(), _vm.getModuleConfig('staff_list_page.multiple_bind.button_text') && !_vm.isCanBinding ? _c('MemberButton', {
    attrs: {
      "button-style": "s-btn-outline-primary",
      "button-text": _vm.getModuleConfig('staff_list_page.multiple_bind.button_text'),
      "button-url": _vm.getModuleConfig('staff_list_page.multiple_bind.button_url'),
      "type": _vm.getModuleConfig('staff_list_page.multiple_bind.button_action')
    }
  }) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }